import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20professional%20workspace%20with%20warm%20amber%20lighting%2C%20dark%20wood%20desk%2C%20legal%20books%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20architectural%20interior%20with%20large%20windows%2C%20elegant%20atmosphere%2C%20warm%20neutral%20tones&width=1600&height=800&seq=hero-bg-01&orientation=landscape"
          alt="成人网站合规运营指南 - 专业合规知识平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-5">
            成人网站合规运营与内容策略完整指南
          </h1>
          <p className="text-base md:text-lg text-white/85 leading-relaxed mb-8 max-w-2xl mx-auto">
            深度解析合规建站流程、内容审核标准、法律要求及运营策略，帮助从业者建立可持续的合规运营体系，规避法律风险。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/legal-compliance"
              className="px-7 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              开始了解合规要求
            </Link>
            <Link
              to="/about"
              className="px-7 py-3 bg-background-50/90 text-foreground-900 rounded-lg font-medium text-sm whitespace-nowrap hover:bg-background-50 transition-colors duration-200"
            >
              关于我们
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="max-w-6xl mx-auto px-4 md:px-6 pb-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="bg-background-50/90 backdrop-blur-sm rounded-lg p-3 text-center hover:bg-background-50 transition-all duration-200 group"
              >
                <div className="w-9 h-9 mx-auto mb-1.5 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                  <i className={`${cat.icon} text-base`}></i>
                </div>
                <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}